<template>
  <div id="app">
    <desktop-site v-if="view == 'large'" />
    <mobile-site v-else />
  </div>
</template>

<script>
import DesktopSite from './views/DesktopSite.vue'
import MobileSite from './views/MobileSite.vue'

import './assets/css/style.css'
export default {
  name: 'app',
  data() {
    return {
      view: ''
    }
  },
  components: {
    MobileSite,
    DesktopSite
  },
  methods: {
    getSize: function() {
      if (window.innerWidth <= 600) {
        this.view = 'small'
      } else {
        this.view = 'large'
      }
    }
  },
  mounted() {
    this.getSize()
    window.onresize = () => {
      this.getSize()
    }
  }
}
</script>

<style>
#app {
}
</style>
